<template>

    <div class="relation656">
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[4])">
                    <img src="https://cdn.edstatic.com/203012120000/f4c235e7d75be79273d4b2ba16766dd9/2025/12/f5c63bb1-e1b4-44e1-81d9-98ff9729d22a.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[2])">
                    <img src="https://cdn.edstatic.com/203012120000/228f108dc894a50a397e0729c73e0c71/2025/12/0005acd5-518e-49a5-9623-33809ed55c42.png"
                        alt="">
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[6])">
                    <img src="https://cdn.edstatic.com/203012120000/40c73501dc7c1147d9a9acb5701c3011/2025/12/12687d9c-562a-4802-a897-04accc4fee88.png"
                        alt="">
                </a>
            </van-col>
        </van-row>
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[1])">
                    <img src="https://cdn.edstatic.com/203012120000/57f74431c64eb65b549470e9116881b6/2025/12/3084c04e-892f-4cc2-8ad6-72eae52a80b6.png"
                        alt="">
                </a>
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[5])">
                    <img src="https://cdn.edstatic.com/203012120000/ab4ee4087900ceb2376ec33f6aa49e99/2025/12/77d02024-7f60-423b-bdf8-a5f073e4349d.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[9])">
                    <img src="https://cdn.edstatic.com/203012120000/10e2f539ae198a17b0d067a48a634b49/2025/12/38fe6392-7dc9-4a81-9c1d-8e1cf15695c6.png"
                        alt="">
                </a>
            </van-col>
           
        </van-row>
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[11])">
                    <img src="https://cdn.edstatic.com/203012120000/1fa452ecc91d14a85e33c3802f5a9485/2025/12/0a656b10-1927-451d-b270-ac3b3c6a367b.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[8])">
                    <img src="https://cdn.edstatic.com/203012120000/e0f6d7e1e9df5beea755e1e6687e3de6/2025/12/e802f4a5-2cdd-431d-a7f0-106d6491cd87.png"
                        alt="">
                </a>
            </van-col>

        </van-row>
        <van-row>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[10])">
                    <img src="https://cdn.edstatic.com/203012120000/75288a049021c1e0e7acf11d67a6d7b0/2025/12/449c3f4a-5fde-4d38-805c-1b6e5c37f0e9.png"
                        alt="">
                </a>
            </van-col>
            <van-col span="12">
                <a href="Javascript:void(0)" title="picname" @click="skipLink(meetingButton[3])">
                    <img src="https://cdn.edstatic.com/203012120000/291b5519b2d04925256e07f3cbc9d2be/2025/12/f2808e17-e74f-4542-a381-a7fa541e7e7b.png"
                        alt="">
                </a>
            </van-col>

        </van-row>
    </div>

</template>
<script>
export default {
    props: {
        meetingButton: Array,
        showButtonText: Number,

    },
    data() {
        return {
            button_rows: 3,
        }
    },
    methods: { // 将 skipLink 方法移至此处
        skipLink(item) {
            console.log(item);
            if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
                ImagePreview({
                    images: [item.url],
                    closeable: true,
                    showIndex: false
                });
            } else {
                window.localStorage.removeItem('callback_url');
                window.localStorage.setItem('callback_url', item.url);
                window.location.href = item.url;

                if (item.url.indexOf('vascularnews/meeting/schedule') > -1 && window.localStorage.getItem('schedule_date')) {
                    window.localStorage.removeItem('schedule_date');
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.relation656 {
    // overflow: auto;
    padding: 0.3rem 0.3rem;
    @include flex(row);
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    .van-row {
        width: 100%;
        line-height: 0;

    }

    .van-col {
        line-height: 0;
    }

    div {
        text-align: center;
    }

    a {
        display: inline-block;
        text-align: center;
        line-height: 0;
        padding: 0.15rem;
        // margin-bottom: 16px;
    }

    img {
        width: 100%;
        height: 100%;

    }
}


.one-column {
    flex-direction: column;
    align-items: flex-start;
}



@media screen and (min-width: 500px) {
    .relation581 a {
        padding: 0.29rem !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Button656.vue